import React from 'react';
import { Div } from '@icecreamsocial/components';
import {
	BusinessEcommerceForm,
	EditFormControls,
	Pagename,
} from '../../../../presentational';
import { useBusiness } from '../../../../providers/Business';

const ECommerceSettings = () => {
	const { business, update } = useBusiness();
	const { data, isLoading } = business;

	const initialValues = {
		webstoreURL: data?.webstoreURL,
		eCommerceSolution: data?.eCommerceSolution,
	};

	const handleSubmit = (values) => update.mutate(values);

	return (
		<Div>
			<Pagename>eCommerce</Pagename>
			<BusinessEcommerceForm
				{...initialValues}
				onSubmit={handleSubmit}
				renderControls={(props) => (
					<EditFormControls
						isLoading={isLoading}
						disabled={isLoading}
						{...props}
					/>
				)}
			/>
		</Div>
	);
};

ECommerceSettings.displayName = 'Settings.Business.Ecommerce';
export default ECommerceSettings;
